export default {
    current_choice: 'Huidige keuze',
    book_now: 'Nu boeken',
    minimum_age: 'Alleen voor {age}+',
    excess_liability: 'Eigen risico',
    security_deposit: 'Borg',
    fuel_policy: 'Brandstofbeleid',
    like_for_like: 'Zelfde voor zelfde',
    full_to_full: 'Vol tot vol',
    miles_per_rental: '{mileage} gratis mijlen per huur',
    km_per_rental: '{mileage} gratis km per huur',
    unlimited_mileage: 'Onbeperkte kilometers',
    unlimited_mileage_km: 'Onbeperkte km',
    non_amendable: 'Niet aanpasbaar',
    non_refundable: 'Niet restitueerbaar',
    free_cancellation_until: 'Gratis annuleren tot',
    basic_free_cancellation: 'Gratis annuleren tot 48 uur voor de starttijd',
    cancellation_in_line_with: 'Annulering volgens',
    tcs: 'Algemene voorwaarden',
    free_extras_on_collection: 'Twee gratis extra’s bij ophalen',
    glass_and_tyres_covered: 'Ruiten en banden gedekt',
    number_of_passengers: 'Aantal passagiers',
    number_of_bags: 'Aantal tassen',
    fuel_type: 'Brandstoftype',
    co2: 'CO2',
    aircon: 'Airco',
    transmission: 'Transmissie',
    book_type: 'Boek {type}',
    debit_card_deposit: 'Pinpas geaccepteerd voor borg',
    fast_track_included: 'Fast Track inbegrepen',
    view_all: 'Alles bekijken',
};
